import "./melaList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import MelaTable from "../melatable/MelaTable";

const MelaList = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <MelaTable />
      </div>
    </div>
  );
};

export default MelaList;
